import React from 'react';

import config from 'config';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useProductDetailContext } from '~/techstyle-shared/react-components';

import useWearItWith from '../../utils/useWearItWith';

import BestSellers from './BestSellers';
import RecommendedWearItWith from './RecommendedWearItWith/RecommendedWearItWith';
import YouWillAlsoLove from './YouWillAlsoLove';

const Wrapper = styled.div`
  margin: 32px auto 0;
  max-width: 936px;
`;

function UpsellModuleSimplified({ wearItWith, youWillAlsoLove }) {
  const { product, isBundle } = useProductDetailContext();
  const { item: itemCodes = [], bundle: bundleCodes = [] } = config.get(
    'public.bestSellerFplCodes'
  );

  const { shouldDisplay: shouldDisplayWearItWith } = useWearItWith({ product });

  return (
    <Wrapper>
      {shouldDisplayWearItWith && wearItWith && (
        <RecommendedWearItWith product={product} />
      )}
      {youWillAlsoLove && (
        <BestSellers fplCodes={isBundle ? bundleCodes : itemCodes} />
      )}
    </Wrapper>
  );
}

UpsellModuleSimplified.propTypes = {
  wearItWith: PropTypes.bool,
  youWillAlsoLove: PropTypes.bool,
};

function UpsellModuleOriginal({ wearItWith, youWillAlsoLove }) {
  const { product } = useProductDetailContext();
  const { shouldDisplay: shouldDisplayWearItWith } = useWearItWith({ product });

  return (
    <Wrapper>
      {shouldDisplayWearItWith && wearItWith && (
        <RecommendedWearItWith product={product} />
      )}
      {youWillAlsoLove && <YouWillAlsoLove product={product} />}
    </Wrapper>
  );
}

UpsellModuleOriginal.propTypes = {
  wearItWith: PropTypes.bool,
  youWillAlsoLove: PropTypes.bool,
};

export default function UpsellModule({
  profileSizes,
  wearItWith = true,
  youWillAlsoLove = true,
}) {
  return config.get('public.useSimplifiedPdpUpsell') ? (
    <UpsellModuleSimplified
      wearItWith={wearItWith}
      youWillAlsoLove={youWillAlsoLove}
    />
  ) : (
    <UpsellModuleOriginal
      profileSizes={profileSizes}
      wearItWith={wearItWith}
      youWillAlsoLove={youWillAlsoLove}
    />
  );
}

UpsellModule.propTypes = {
  profileSizes: PropTypes.any,
  wearItWith: PropTypes.bool,
  youWillAlsoLove: PropTypes.bool,
};
